export const REGION = 'us-east-1';
export const USER_POOL_ID = 'us-east-1_q6VnLIjBe';
export const APP_CLIENT_ID = '3f1l1jm346god8qostma0dcfs9';
export const IDENTITY_POOL_ID = 'us-east-1:ad9941ec-5f81-40ec-b82a-e6acd7d49269';
export const COGNITO_DOMAIN = 'ee-portal-auth-gamma.auth.us-east-1.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'gamma';
export const APPEAL_ENABLED = 'true';